import { FlexContainer } from '@facephi/ui-react';
import styled from 'styled-components/macro';

export const StyledContainer = styled(FlexContainer)<{ $withPadding: boolean }>`
  padding: ${(props) => (props.$withPadding ? '1.6rem' : '0')};
`;
